<template>
  <div class="home-component">
    <v-parallax :src="require('@/assets/bg.jpg')" height="500">
      <v-container>
        <v-layout justify-center>
          <v-row>
            <v-col cols="12" md="6">
              <h1 class="display-3 mt-4 mb-5 font-weight-bold">
                {{ $t("title") }}
              </h1>
              <h2 class="headline mb-10">
                {{ $t("short") }}
              </h2>
              <v-text-field
                v-model="search"
                :placeholder="$t('search_for') + '...'"
                filled
                clearable
                v-bind="searchBarMode"
                outlined
                rounded
                @input="searchForFn()"
                prepend-inner-icon="fa-search"
                @click:prepend-inner="searchForFn()"
                @click:clear="clear()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-layout>
      </v-container>
    </v-parallax>
    <v-container>
      <v-card
        class="bg pa-4"
        elevation="0"
        style="margin-top: -4rem"
        min-height="300px"
      >
        <dikr-list :items="items"></dikr-list>
        <v-card-actions class="mt-5">
          <v-pagination
            v-model="page"
            :length="pagesLength"
            @input="increase"
          ></v-pagination>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import DikrList from "@/components/DikrList.vue";

export default {
  components: { DikrList },
  name: "home",
  computed: {
    searchBarMode() {
      if (this.darkMode) {
        return { dark: true, "background-color": "bg" };
      } else {
        return { light: true, "background-color": "white" };
      }
    },
  },
  data: () => ({
    items: [],
    original: [],
    search: "",
    listStillLoading: true,
    page: 1,
    pagesLength: 0,
    x: 9,
  }),
  created() {
    this.$store.getters.getAll.forEach((el) => {
      this.original.push({ TITLE: el.TITLE, slug: this.kebabCase(el.TITLE) });
    });
    this.items = this.paginate(1);
    this.pagesLength = Number((this.original.length / this.x).toFixed(0));
  },
  mounted() {
    this.listStillLoading = false;
  },
  methods: {
    searchForFn() {
      if (!this.search) {
        // this.items = this.original;
        this.items = this.paginate(1);
      } else {
        this.items = this.original.filter((el) => {
          return el.slug.includes(this.search);
        });
      }
    },
    clear() {
      this.items = this.paginate(1);
    },
    increase(n) {
      this.items = this.paginate(n);
    },
    paginate(page_number) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      const page_size = this.x;
      return this.original.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
  },
  metaInfo: {
    title: "الرئيسية",
  },
};
</script>
